import { render } from "./Onboarding.vue?vue&type=template&id=44015f66&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=44015f66&lang=css"
import "./Onboarding.vue?vue&type=style&index=1&id=44015f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44015f66"]])

export default __exports__